/**@param  {string | ??}string*/
export function capitalizeString(string) {
    let charts = string.split('-');
    let convert = charts.map(/**@param {string}item*/(item) => {
        return item.charAt(0).toUpperCase() + item.slice(1);
    })
    let result = convert.join(' ');
    return result
}